import {
  PaginatedTaskTypeListReadable,
  TaskTypeReadable,
  TaskTypesListData,
  taskTypesListInfiniteOptions
} from '@crm/api'
import { InfiniteSelect } from '@crm/components'
import { listTransformResults, TagPriorityByValue } from '@crm/utils'
import { useLocales } from '@shared/locales'

import { Form, FormInstance, Input, Radio, Tag } from 'antd'

type Props = {
  form: FormInstance
}

export const FormNomenclaturesTasksTemplates = ({ form }: Props) => {
  const { t } = useLocales()

  const type = Form.useWatch('type', form)

  return (
    <>
      <Form.Item
        name="title"
        label={t('nomenclature.name')}
        rules={[{ required: true }]}
      >
        <Input />
      </Form.Item>

      <Form.Item name="description" label={t('nomenclature.description')}>
        <Input.TextArea rows={4} placeholder={t('task.description')} />
      </Form.Item>

      <Form.Item name="type" label={t('task.task_type')}>
        <InfiniteSelect<
          TaskTypesListData,
          PaginatedTaskTypeListReadable,
          TaskTypeReadable
        >
          popupMatchSelectWidth
          placeholder={t('main.select')}
          getQueryFunction={taskTypesListInfiniteOptions}
          getOptions={({ options }) => listTransformResults(options)}
          baseOptions={{
            query: {
              preference: type ? [type] : undefined
            }
          }}
        />
      </Form.Item>

      <Form.Item name="priority" label={t('task.priority')}>
        <Radio.Group
          style={{ display: 'flex', gap: '8px 0', flexWrap: 'wrap' }}
          size="small"
          options={Object.entries(TagPriorityByValue(t)).map(
            ([key, value]) => ({
              label: <Tag color={value.color}>{value.title}</Tag>,
              value: Number(key)
            })
          )}
        />
      </Form.Item>
    </>
  )
}
